import "./SocialIcons.scss"
import { SocialIcon } from 'react-social-icons';
import viber from '../../icons/viber.svg'
import instagram from '../../icons/icons-instagram.svg'
import youtube from '../../icons/youtube-svgrepo-com (1).svg'
import React from 'react';

export default function SocialIcons() {
  return (
    <div className="social__icons">
      <SocialIcon url="https://www.facebook.com/%D0%A1%D0%B0%D0%BD%D0%B1%D0%B5%D1%80%D1%80%D1%96-%D0%A3%D0%BA%D1%80%D0%B0%D1%97%D0%BD%D0%B0-103192682345184" target="_blank" />
      <SocialIcon network="telegram" url="https://t.me/Sunberry_ukr" target="_blank" rel="noreferrer" />
      <a className="viber" href="viber://chat?number=%2B380683699030" target="_blank" rel="noreferrer">
        <img className="social__icons--viber" src={viber} alt="viber" />
      </a>
      <a className="instagram" href="https://www.instagram.com/sunberry_ukraine?igsh=a3IxNDY1eGZhbDB0" target="_blank" rel="noreferrer">
        <img className="social__icons--instagram" src={instagram} alt="instagram" />
      </a>
      <a className="youtube" href="https://www.youtube.com/channel/UCSEISvMPvDAYica-m7taelQ" target="_blank" rel="noreferrer">
        <img className="social__icons--youtube" src={youtube} alt="youtube" />
      </a>
    </div>
  );
}
